import api from './api';

const SESSION_KEY = 'khayr_visit_session';

function getSessionId() {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

function detectDevice() {
  const ua = navigator.userAgent || '';
  if (/tablet|ipad|playbook|silk|(android(?!.*mobile))/i.test(ua)) return 'tablet';
  if (/mobi|iphone|ipod|android|blackberry|opera mini|iemobile/i.test(ua)) return 'mobile';
  return 'desktop';
}

function detectSource(search, referrer) {
  try {
    const params = new URLSearchParams(search || '');
    const utm = (params.get('utm_source') || '').toLowerCase();
    if (utm.includes('google')) return 'google';
    if (utm.includes('facebook') || utm.includes('fb')) return 'facebook';
    if (utm.includes('instagram') || utm === 'ig') return 'instagram';
    if (utm.includes('whatsapp') || utm === 'wa') return 'whatsapp';
    if (utm) return 'other';
  } catch {
    // ignore
  }

  const ref = (referrer || '').toLowerCase();
  if (!ref) return 'direct';
  if (ref.includes('google.') || ref.includes('bing.') || ref.includes('yahoo.')) return 'google';
  if (ref.includes('facebook.') || ref.includes('fb.')) return 'facebook';
  if (ref.includes('instagram.')) return 'instagram';
  return 'other';
}

function pageLabelFromPath(pathname) {
  const path = (pathname || '/').replace(/^\/(ar|fr)(?=\/|$)/, '') || '/';
  const map = {
    '/': 'Accueil',
    '/donate': 'Dons',
    '/programmes': 'Programmes',
    '/programmes/kafala': 'Kafala',
    '/stats': 'Statistiques publiques',
    '/about': 'À propos',
    '/volunteer': 'Bénévolat',
    '/actualites': 'Actualités',
    '/dossiers': 'Dossiers',
    '/legal': 'Mentions légales',
  };
  if (map[path]) return map[path];
  if (path.startsWith('/programmes/kafala/orphelins')) return 'Orphelin (public)';
  if (path.startsWith('/programmes/')) return 'Programme';
  if (path.startsWith('/projets/')) return 'Projet';
  if (path.startsWith('/actualites/')) return 'Actualité';
  return path;
}

/** Enregistre une visite de page publique (best-effort, silencieux). */
export async function trackPageVisit(pathname = window.location.pathname) {
  try {
    if (!pathname || pathname.startsWith('/admin') || pathname.startsWith('/login')) {
      return;
    }

    await api.post('/public/page-visits', {
      path: pathname,
      page_label: pageLabelFromPath(pathname),
      device: detectDevice(),
      source: detectSource(window.location.search, document.referrer),
      referrer: document.referrer || null,
      session_id: getSessionId(),
    });
  } catch {
    // Ne jamais bloquer la navigation
  }
}

export async function getVisitAnalytics(days = 30) {
  const { data } = await api.get('/admin/analytics/visits', { params: { days } });
  return data;
}
